import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setSender_NamesList, setSender_NamesMessage, setShortlinksList, setShortlinksMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import Layout from "template";
import { Constant } from "template/Constant";
import { Short_LinksForm } from "./form";
import { Short_LinksTable } from "./table";
import { getShortLinks } from "services/short_linksService";

export const Short_Links: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.short_links);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState("");
  const getData = (page, pageSize) => {
    getShortLinks(page, pageSize).then((response) => {
      if (response && response.records) {
        dispatch(
          setShortlinksList({
            pageNo: page,
            pageSize: pageSize,
            list: response.records,
            totalCount: response.totalCount,
          })
        );
      } else {
        dispatch(
          setSender_NamesMessage({
            text: "No Record Found",
            type: Constant.alertVariantDanger,
          })
        );
      }
    });
  };

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(
      setSender_NamesMessage({ text: "", type: Constant.alertVariantSuccess })
    );
    setAction("edit");
  };
  return (
    <Layout>
      <div className="container-fluid">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Короткие ссылки</h1>
        </div>
        <div className="d-flex flex-column min-vh-100">
          {rData.message.text ? (
            <Alert
              variant={rData.message.type}
              className="alert-dismissible fade"
            >
              {rData.message.text}
              <Button
                type="button"
                className="close"
                data-dismiss="alert"
                aria-label="Close"
                onClick={() =>
                  dispatch(
                    setShortlinksMessage({
                      text: "",
                      type: Constant.alertVariantSuccess,
                    })
                  )
                }
              >
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert>
          ) : null}
          {action ? (
            <Short_LinksForm
              hideShowForm={setAction}
              action={action}
              row={row}
              getData={getData}
            />
          ) : (
            <Short_LinksTable
              handleRowEdit={handleRowEdit}
              hideShowForm={setAction}
              getData={getData}
            />
          )}
        </div>
      </div>
    </Layout>
  );
};
